import AssignPropertyToPortfolioModal from "./AssignPropertyToPortfolioModalContainer";

export default AssignPropertyToPortfolioModal;
